<template>
  <!-- 全局下拉选 -->
  <div class="select-wrap">
    <p class="name">
      {{ $t('重复频率') }}
    </p>
    <select @change="selectChange">
      <option v-for="(item, index) in state.options" :key="index" :value="item.id" :selected="item.selected">{{ item.txt }}</option>
    </select>


    <div v-if="mainValue == 2">
      <p>
        {{ $t('频率：') }}
      </p>
      <el-select v-model="frequencyValue" placeholder="Select">
        <el-option
            v-for="item in state.options1"
            :key="item.value"
            :label="item.label"
            :value="item.value"
            :disabled="item.disabled"
        />
      </el-select>
      <el-select v-model="value1" placeholder="Select">
        <el-option
            v-for="item in state.options2"
            :key="item.value"
            :label="item.label"
            :value="item.value"
            :disabled="item.disabled"
        />
      </el-select>
    </div>

    <div v-if="mainValue == 2 && value1 == 2">
      <p>
        {{ $t('日期：') }}
      </p>
      <el-select
          v-model="value3"
          multiple
          placeholder="Select"
          style="width: 100%"
      >
        <el-option
            v-for="item in state.options3"
            :key="item.value"
            :label="item.label"
            :value="item.value"
        />
      </el-select>
    </div>

    <div v-if="mainValue == 2 && value1 == 1">
      <p>
        {{ $t('发生于：') }}
      </p>
      <div>
        <el-checkbox v-model="checked1" label="周一" size="large" />
        <el-checkbox v-model="checked2" label="周二" size="large" />
        <el-checkbox v-model="checked3" label="周三" size="large" />
        <el-checkbox v-model="checked4" label="周四" size="large" />
        <el-checkbox v-model="checked5" label="周五" size="large" />
        <el-checkbox v-model="checked6" label="周六" size="large" />
        <el-checkbox v-model="checked7" label="周日" size="large" />
      </div>
    </div>



    <div v-if="mainValue == 1 ||  mainValue == 2">
      <p>
        {{ $t('结束于：') }}
      </p>
      <el-select v-model="value2" placeholder="Select">
        <el-option
            v-for="item in state.endOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
            :disabled="item.disabled"
        />
      </el-select>
      <el-input-number v-if="value2 == 2" v-model="state.num" :min="1" :max="10" />
      <el-date-picker
          v-if="value2 == 1"
          v-model="value4"
          type="date"
          placeholder="Pick a day"
          size="large"
      />
    </div>

  </div>
</template>
<script setup>

import {getCurrentInstance, reactive,ref} from "vue";

const emit = defineEmits();
import { useStore } from 'vuex';
const store = useStore();
import { useRouter } from 'vue-router';
const router = useRouter();
// 多语言调用
const { appContext : { config: { globalProperties } } } = getCurrentInstance();
const props = defineProps({
  modelValue: Number
})
const mainValue = ref('')
const frequencyValue = ref('')
const value1 = ref('')
const value2 = ref('')
const value3 = ref([])
const value4 = ref('')
const checked1 = ref(false)
const checked2 = ref(false)
const checked3 = ref(false)
const checked4 = ref(false)
const checked5 = ref(false)
const checked6 = ref(false)
const checked7 = ref(false)
const state = reactive({
  options: [
    {
      id: 0,
      txt: "不重复"
    },
    {
      id: 1,
      txt: "每天"
    },
    {
      id: 2,
      txt: "自定义"
    },
  ],
  options1: [
    {
      value: 1,
      label: "每1"
    },
    {
      value: 2,
      label: "每2"
    },
    {
      value: 3,
      label: "每3"
    },
    {
      value: 4,
      label: "每4"
    },
    {
      value: 5,
      label: "每5"
    },
    {
      value: 6,
      label: "每6"
    },
    {
      value: 7,
      label: "每7"
    },
    {
      value: 8,
      label: "每8"
    },
    {
      value: 9,
      label: "每9"
    },
  ],
  options2: [
    {
      value: 0,
      label: "天"
    },
    {
      value: 1,
      label: "周"
    },
    {
      value: 2,
      label: "月"
    },
  ],
  options3: [
    {value: 1, label: "1"}, {value: 2, label: "2"}, {value: 3, label: "3"}, {value: 4, label: "4"},{value: 5, label: "5"},
    {value: 6, label: "6"}, {value: 7, label: "7"}, {value: 8, label: "8"}, {value: 9, label: "9"},{value: 10, label: "10"},
    {value: 11, label: "11"}, {value: 12, label: "12"}, {value: 13, label: "13"}, {value: 14, label: "14"},{value: 15, label: "15"},
    {value: 16, label: "16"}, {value: 17, label: "17"}, {value: 18, label: "18"}, {value: 19, label: "19"},{value: 20, label: "20"},
    {value: 21, label: "21"}, {value: 22, label: "22"}, {value: 23, label: "23"}, {value: 24, label: "24"},{value: 25, label: "25"},
    {value: 26, label: "26"}, {value: 27, label: "27"}, {value: 28, label: "28"}, {value: 29, label: "29"},{value: 30, label: "30"},
  ],
  endOptions: [
    {
      value: '1',
      label: '某天',
    },
    {
      value: '2',
      label: '限定会议次数',
    },
  ],

  num: 1,

})

function selectChange(event) {
  emit("update:modelValue", event.target.value);
  console.log(event.target.value == 1)
  mainValue.value = event.target.value
}
</script>
<style scoped>
.select-wrap {
  width: 30.20833vw;
  margin: 0 auto;
}

.select-wrap .name {
  font-size: 0.9375vw;
  line-height: 1.30208vw;
  font-weight: bold;
  color: #2F3367;
  margin-bottom: 0.41666vw;
}

.select-wrap select {
  display: block;
  width: 100%;
  font-size: 0.83333vw;
  line-height: 1.14583vw;
  box-sizing: border-box;
  border: 0.05208vw solid #D4D6D8;
  border-radius: 0.20833vw;
  padding: 0.72916vw 1.25vw;
  background: url("../../assets/img/icons/icon-arr-down.png") no-repeat;
  background-size: 1.14583vw 1.04166vw;
  background-position: right 1.25vw center;
  transition: border-color .2s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.select-wrap select:hover {
  border-color: #aaaeb7;
}

@media screen and (max-width: 750px) {

  .select-wrap {
    width: 82.93333vw;
  }

  .select-wrap .name {
    font-size: 3.73333vw;
    line-height: 5.33333vw;
    margin-bottom: 1.6vw;
  }

  .select-wrap select {
    font-size: 3.73333vw;
    line-height: 5.33333vw;
    padding: 2.66666vw 3.2vw;
    background-size: 4.26666vw;
    border-radius: 0.53333vw;
    border-width: 0.13333vw;
  }

}
</style>
